<template>
    <div class="no__data">
        <img src="/docs/images/no-result.png" width="440" height="330"/>

        <div class="header__wrapper">
            <p>{{ mainText }}</p>
            <svg>
                <use xlink:href="#ico-smiley"></use>
            </svg>
        </div>

        <p class="header__info">{{ text }}</p>

        <slot></slot>
    </div>
</template>

<script>
export default {
  props: {
    mainText: {
      type: String,
      default: 'Whoops, no matches'
    },
    text: {
      type: String,
      default: "We couldn't find any search results. Give it another go"
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/NoData.vue